export default {
  badge: 'Placa',
  open: 'Abrir',
  close: 'Cerrar',
  dismiss: 'Descartar',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Cancelar',
  },
  dataIterator: {
    noResultsText: 'Ningún elemento coincide con la búsqueda',
    loadingText: 'Cargando...',
  },
  dataTable: {
    itemsPerPageText: 'Filas por página:',
    ariaLabel: {
      sortDescending: 'Orden descendente.',
      sortAscending: 'Orden ascendente.',
      sortNone: 'Sin ordenar.',
      activateNone: 'Pulse para quitar orden.',
      activateDescending: 'Pulse para ordenar de forma descendente.',
      activateAscending: 'Pulse para ordenar de forma ascendente.',
    },
    sortBy: 'Ordenado por',
  },
  dataFooter: {
    itemsPerPageText: 'Elementos por página:',
    itemsPerPageAll: 'Todos',
    nextPage: 'Página siguiente',
    prevPage: 'Página anterior',
    firstPage: 'Primera página',
    lastPage: 'Última página',
    pageText: '{0}-{1} de {2}',
  },
  dateRangeInput: {
    divider: 'a',
  },
  datePicker: {
    itemsSelected: '{0} seleccionados',
    range: {
      title: 'Seleccionar fechas',
      header: 'Introducir fechas',
    },
    title: 'Seleccionar fecha',
    header: 'Introducir fecha',
    input: {
      placeholder: 'Introducir fecha',
    },
  },
  noDataText: 'No hay datos disponibles',
  carousel: {
    prev: 'Visual anterior',
    next: 'Visual siguiente',
    ariaLabel: {
      delimiter: 'Visual {0} de {1}',
    },
  },
  calendar: {
    moreEvents: '{0} más',
    today: 'Hoy',
  },
  input: {
    clear: 'Borrar {0}',
    prependAction: '{0} acción adelantada',
    appendAction: '{0} acción añadida',
    otp: 'Por favor, introduzca el carácter OTP {0}',
  },
  fileInput: {
    counter: '{0} archivos',
    counterSize: '{0} archivos ({1} en total)',
  },
  fileUpload: {
    title: 'Arrastra y suelta archivos aquí',
    divider: 'o',
    browse: 'Explorar archivos',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Seleccionar hora',
  },
  pagination: {
    ariaLabel: {
      root: 'Navegación de paginación',
      next: 'Página siguiente',
      previous: 'Página anterior',
      page: 'Ir a la página {0}',
      currentPage: 'Página actual, página {0}',
      first: 'Primera página',
      last: 'Última página',
    },
  },
  stepper: {
    next: 'Siguiente',
    prev: 'Anterior',
  },
  rating: {
    ariaLabel: {
      item: 'Puntuación {0} de {1}',
    },
  },
  loading: 'Cargando...',
  infiniteScroll: {
    loadMore: 'Cargar más',
    empty: 'No hay más',
  },
  rules: {
    required: 'Este campo es obligatorio',
    email: 'Por favor, introduce un correo electrónico válido',
    number: 'Este campo solo puede contener números',
    integer: 'Este campo solo puede contener valores enteros',
    capital: 'Este campo solo puede contener letras mayúsculas',
    maxLength: 'Debes introducir un máximo de {0} caracteres',
    minLength: 'Debes introducir un mínimo de {0} caracteres',
    strictLength: 'La longitud del campo introducido no es válida',
    exclude: 'El carácter {0} no está permitido',
    notEmpty: 'Por favor, elige al menos un valor',
    pattern: 'Formato inválido',
  },
}
